export const Version = window.VERSION;
export default window.CONFIG;
